module.exports = {
	"pagination": {
		"DescribeScalableTargets": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "ScalableTargets"
		},
		"DescribeScalingPolicies": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "ScalingPolicies"
		},
		"DescribeScalingActivities": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults",
			"result_key": "ScalingActivities"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/application-autoscaling-2016-02-06.paginators.json
// module id = 641
// module chunks = 2